"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useScrollRelative;

var _react = require("react");

var _useWebChatUIContext2 = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useScrollRelative() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      scrollRelativeCallbacksRef = _useWebChatUIContext.scrollRelativeCallbacksRef;

  return (0, _react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return scrollRelativeCallbacksRef.current.forEach(function (callback) {
      return callback.apply(void 0, args);
    });
  }, [scrollRelativeCallbacksRef]);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VTY3JvbGxSZWxhdGl2ZS5qcyJdLCJuYW1lcyI6WyJ1c2VTY3JvbGxSZWxhdGl2ZSIsInNjcm9sbFJlbGF0aXZlQ2FsbGJhY2tzUmVmIiwiYXJncyIsImN1cnJlbnQiLCJmb3JFYWNoIiwiY2FsbGJhY2siXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQTs7OztBQUVlLFNBQVNBLGlCQUFULEdBQTZCO0FBQzFDLDZCQUF1QyxvQ0FBdkM7QUFBQSxNQUFRQywwQkFBUix3QkFBUUEsMEJBQVI7O0FBRUEsU0FBTyx3QkFDTDtBQUFBLHNDQUFJQyxJQUFKO0FBQUlBLE1BQUFBLElBQUo7QUFBQTs7QUFBQSxXQUFhRCwwQkFBMEIsQ0FBQ0UsT0FBM0IsQ0FBbUNDLE9BQW5DLENBQTJDLFVBQUFDLFFBQVE7QUFBQSxhQUFJQSxRQUFRLE1BQVIsU0FBWUgsSUFBWixDQUFKO0FBQUEsS0FBbkQsQ0FBYjtBQUFBLEdBREssRUFFTCxDQUFDRCwwQkFBRCxDQUZLLENBQVA7QUFJRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ2FsbGJhY2sgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB1c2VXZWJDaGF0VUlDb250ZXh0IGZyb20gJy4vdXNlV2ViQ2hhdFVJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNjcm9sbFJlbGF0aXZlKCkge1xuICBjb25zdCB7IHNjcm9sbFJlbGF0aXZlQ2FsbGJhY2tzUmVmIH0gPSB1c2VXZWJDaGF0VUlDb250ZXh0KCk7XG5cbiAgcmV0dXJuIHVzZUNhbGxiYWNrKFxuICAgICguLi5hcmdzKSA9PiBzY3JvbGxSZWxhdGl2ZUNhbGxiYWNrc1JlZi5jdXJyZW50LmZvckVhY2goY2FsbGJhY2sgPT4gY2FsbGJhY2soLi4uYXJncykpLFxuICAgIFtzY3JvbGxSZWxhdGl2ZUNhbGxiYWNrc1JlZl1cbiAgKTtcbn1cbiJdfQ==